class TabbedCollection {
  constructor() {
    const collectionGroup = [].slice.call(
      document.querySelectorAll('.tabbed-collection')
    );

    if (collectionGroup.length > 0) {
      collectionGroup.forEach(group => {
        this.sectionTabbing(group);
      });
    }
  }

  // TODO: GLOBALIZE THIS FUNCTION
  sectionTabbing(item) {
    this.groupTabs = [].slice.call(
      item.querySelectorAll('.tabbed-collection__controls-button')
    );

    this.groupCollections = [].slice.call(
      item.querySelectorAll('.tabbed-collection__wrapper')
    );
    
    this.groupTabs.forEach(tab => {

      ['click', 'keypress'].forEach(event => {
        tab.addEventListener(event, e => {
          const key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            let group = tab.dataset.group;

            [].forEach.call(this.groupTabs, function(el) {
              el.classList.remove('current');
            });

            [].forEach.call(this.groupCollections, function(el) {
              el.classList.remove('current');
            });

            tab.classList.add('current')

            this.groupCollections.forEach(collection => {
              if (collection.dataset.group === group) {
                collection.classList.add('current')
              }
            })
          }
        });
      });
    })
  }
}

const tabbedCollectionInit = {
  init() {

    const collectionElem = [].slice.call(document.querySelectorAll('.tabbed-collection'));
    if (collectionElem.length > 0) {
      collectionElem.forEach(el => {

        new TabbedCollection(el);
      });
    }
  },
};

export default tabbedCollectionInit;
